import React from "react";

const Welcome = () => {
  const handleGoHome = () => {
    // Redirige al inicio de tu web. Cambia "/" por tu ruta principal si es necesario.
    window.location.href = "/";
  };

  return (
    <section className="relative min-h-screen mx-auto px-4 flex flex-col items-center justify-center mt-16">
      <div className="container max-w-md px-6 mx-auto py-12 flex flex-col items-center">
        
        {/* Tarjeta contenedora */}
        <div className="w-full p-8 bg-white backdrop-blur-sm bg-opacity-50 rounded-xl text-center shadow-md flex flex-col items-center gap-6">
          
          {/* Icono de Check / Éxito */}
          <div className="w-20 h-20 bg-gradient-to-r from-quaternary to-tertiary rounded-full flex items-center justify-center shadow-inner">
            <svg
              className="w-10 h-10 text-black"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
                d="M5 13l4 4L19 7"
              ></path>
            </svg>
          </div>

          {/* Información de Bienvenida */}
          <div className="flex flex-col gap-3">
            <h1 className="text-secondary text-2xl md:text-3xl font-bold">
              ¡Bienvenido a nuestra membresía!
            </h1>
            <p className="text-gray-800 text-base md:text-lg font-medium mt-2 leading-relaxed">
              Ya podés disfrutar la tranquilidad de tener técnicos confiables siempre a tu disposición.
            </p>
          </div>

          {/* Botón para regresar al sitio */}
          <div className="w-full mt-4">
            <button
              onClick={handleGoHome}
              className="w-full bg-gradient-to-r from-quaternary to-tertiary text-black hover:text-white hover:to-secondary hover:from-secondary transition px-6 py-3 rounded-lg font-bold shadow-md"
            >
              Ir al Inicio
            </button>
          </div>

        </div>
      </div>

      {/* Imagen de fondo compartida para consistencia de marca */}
      <img
        className="absolute w-full h-full object-cover -z-20"
        src="/asociarme.jpg"
        alt="apreton de manos"
      />
    </section>
  );
};

export default Welcome;